// extracted by mini-css-extract-plugin
export var editor = "_18-0";
export var flowSidebar = "_4h-2";